import { useAccountTypeNavigation } from "../../../hooks/useAccountTypeNavigation";
import { SYSTEMS_BREADCRUMB, SYSTEMS_PATH, SYSTEMS_STRUCTURE_CRUMBS } from "./systems.constants";

export function useSystemsNavigation() {
  return useAccountTypeNavigation({
    path: SYSTEMS_PATH,
    listBreadcrumb: SYSTEMS_BREADCRUMB.list,
    structureCrumbs: SYSTEMS_STRUCTURE_CRUMBS,
  });
}
